import * as actionTypes from 'constants/actionTypes';

const initialState = {
  synced: false,
  userEvents: {},
};

export default function userEvents(state = initialState, action) {
  switch (action.type) {
    case actionTypes.UPDATE_USER_EVENT_IN_STORE:
      return {
        ...state,
        userEvents: {
          ...state.userEvents,
          [action.payload.eventId]: {
            ...state.userEvents[action.payload.eventId],
            ...action.payload.changes,
          },
        },
      };
    case actionTypes.REPLACE_ACCOUNT_USER_EVENT:
      return {
        ...state,
        userEvents: {
          ...state.userEvents,
          [action.payload.eventId]: action.payload.userEvent,
        },
      };
    case actionTypes.REPLACE_ACCOUNT_USER_EVENTS:
      return {
        synced: true,
        userEvents: action.payload,
      };
    case actionTypes.DELETE_ACCOUNT_USER_EVENT_IN_STORE: {
      const { userEventId } = action.payload;
      const { [userEventId]: omit, ...stateWithoutUserEvent } =
        state.userEvents;
      return { ...state, userEvents: stateWithoutUserEvent };
    }
    case actionTypes.CLEAR_ACCOUNT_DATA:
      return initialState;
    default:
      return state;
  }
}

export const selectAccountUserEvent = (state, eventId) =>
  state.account.userEvents.userEvents[eventId];
export const selectAccountUserEvents = state =>
  state.account.userEvents.userEvents;
export const selectBuilderEvents = state =>
  Object.keys(selectAccountUserEvents(state))
    .filter(name => name.startsWith('appcues_custom:'))
    .reduce((acc, name) => {
      acc[name] = selectAccountUserEvent(state, name);
      return acc;
    }, {});
export const selectEventTargetingOptions = state =>
  Object.values(selectAccountUserEvents(state) || {})
    .filter(({ showInUI }) => showInUI)
    .map(userEvent => ({
      label: userEvent.name.replace('appcues_custom:', ''),
      value: userEvent.name,
    }));
